module.exports = __webpack_public_path__ + "static/media/copy.1c57c4d4.png";